import React from 'react';
import LanguageToggle from './LanguageToggle';
import { AboutYouText } from 'src/packages/cli/constants/AboutYouText';
/** Convert an ITranslatable to a FieldLabel */
export const toFieldLabel = (translatable) => ({
    en: translatable.english,
    es: translatable.spanish,
});
export const resolveLabel = (label) => 'en' in label ? label : toFieldLabel(label);
// export const fieldRequiredMsg = (label: FieldLabelInput) => {
//   const l = resolveLabel(label);
//   return <LanguageToggle en={`${l.en} is required.`} es={`${l.es} es obligatorio.`} />;
// };
export const selectionRequiredMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`Please select ${l.en}.`} es={`Por favor seleccione ${l.es}.`}/>;
};
export const fieldInvalidMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} is not valid.`} es={`${l.es} no es válido.`}/>;
};
export const nameInvalidMsg = (label) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} is not valid. ${AboutYouText.nameError.english}`} es={`${l.es} no es válido. ${AboutYouText.nameError.spanish}`}/>;
};
export const fieldErrorMsg = (label, enMsg, esMsg) => {
    const l = resolveLabel(label);
    return <LanguageToggle en={`${l.en} ${enMsg}`} es={`${l.es} ${esMsg}`}/>;
};
